module.exports = {
	baseUrl:'/api',
	//baseUrl:: 'http://112.74.77.143:8905',
   //baseUrl: 'http://192.168.8.95',
   //baseUrl: 'http://192.168.8.168',
   appId:'wxefd841fda50c113f'
}
